import { RouterProvider } from '@tanstack/react-router';
import { useAuth0 } from '@auth0/auth0-react';
import useFetchAuthMetadata from '../hooks/useFetchAuthMetadata';
import { Loader } from '../components/Loader';

interface AuthenticatedAppProviderProps {
  router: any; //TODO: Type this properly
}

/**
 * This wraps the Tanstack RouterProvider passes in additional context including the Auth0 values
 *
 * @param router
 * @returns
 */
export const AuthenticatedAppProvider: React.FC<
  AuthenticatedAppProviderProps
> = ({ router }) => {
  const { isAuthenticated, isLoading } = useAuth0();
  const { metadata, isLoadingMetadata } = useFetchAuthMetadata();

  // If auth is still loading, show the loader
  if (isLoading) {
    return <Loader />;
  }

  // If user is not authenticated, we don't need to wait for metadata
  // If user is authenticated, wait until metadata is loaded
  if (isAuthenticated && isLoadingMetadata) {
    return <Loader />;
  }

  return (
    <>
      <RouterProvider
        router={router}
        context={{
          auth: { isAuthenticated, isLoading },
          authMetadata: {
            groupIds: metadata?.management?.groupIds,
            isLoadingMetadata: isLoadingMetadata,
          },
        }}
      />
    </>
  );
};
